import { supabase } from './supabase';
import { log } from '../components/DebugLogger';

export async function logFailedImage(cardId: string, imageUrl: string) {
  try {
    // Skip logging if the URL is the current page URL (common error from clicking)
    if (imageUrl.includes(window.location.host) && !imageUrl.includes('/storage/')) {
      return;
    }
    
    console.error(`[ImageLogger] Failed to load image for card ${cardId}: ${imageUrl}`);
    
    // Extract basic info about the image
    const isWebp = imageUrl.endsWith('.webp');
    const isPng = imageUrl.endsWith('.png');
    const isSmall = imageUrl.includes('_small');
    const isLarge = imageUrl.includes('_large');
    const bucket = imageUrl.includes('pokemon-images-webp') ? 'pokemon-images-webp' : 'pokemon-images';
    
    // Log additional details
    console.error(`[ImageLogger] Image details:`, {
      cardId,
      imageUrl,
      format: isWebp ? 'webp' : isPng ? 'png' : 'unknown',
      size: isSmall ? 'small' : isLarge ? 'large' : 'unknown',
      bucket,
      timestamp: new Date().toISOString()
    });

    // Only log to database if it's a Supabase storage URL
    if (imageUrl.includes('supabase.co/storage')) {
      // Check if this error has already been logged
      const { data: existingEntry } = await supabase
        .from('failed_images')
        .select('id')
        .eq('card_id', cardId)
        .eq('image_url', imageUrl)
        .maybeSingle();

      if (!existingEntry) {
        const { error } = await supabase
          .from('failed_images')
          .insert({
            card_id: cardId,
            image_url: imageUrl,
            error_message: `Failed to load ${isWebp ? 'WebP' : 'PNG'} ${isSmall ? 'small' : 'large'} image from ${bucket}`
          });

        if (error) {
          console.error('[ImageLogger] Error logging to database:', error);
        }
      } else {
        // Update existing entry to mark it's still failing
        const { error } = await supabase
          .from('failed_images')
          .update({
            resolved: false,
            resolved_at: null
          })
          .eq('id', existingEntry.id);
          
        if (error) {
          console.error('[ImageLogger] Error updating existing entry:', error);
        }
      }
    }

    // Log to debug console
    log(`Failed to load image for card ${cardId} (${imageUrl})`, 'image');
  } catch (error) {
    console.error('[ImageLogger] Error in logging process:', error);
  }
}